import { render, staticRenderFns } from "./AdminPresidentiIdView.vue?vue&type=template&id=ec0cc692&"
import script from "./AdminPresidentiIdView.vue?vue&type=script&lang=ts&"
export * from "./AdminPresidentiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports